// react
import React from "react";

// components
import EmployeeCard from "../../components/EmployeeCard";

import { useUser } from "../../api/hooks";

/**
 * Augments the Employee Card by connecting it to the redux store.
 */

type AugmentedEmployeeCardProps = {
	maxWidth?: string | null;
	employeeID: string;
};

const AugmentedEmployeeCard = ({ employeeID, maxWidth }: AugmentedEmployeeCardProps) => {
	const isDetailsPage = window.location.href.indexOf("details") > -1;

	const { data: user, isLoading } = useUser({ userID: employeeID });

	return (
		<EmployeeCard
			employeeData={{
				id: employeeID,
				name: user?.name,
				jobTitle: typeof user?.jobTitle === "string" ? user.jobTitle : user?.jobTitle?.join(", "),
				role: user?.role?.name,
				email: user?.email,
				isActive: user?.active,
			}}
			isDashboardCard={false}
			isLoading={isLoading}
			isDetailsPage={isDetailsPage}
			maxWidth={maxWidth}
		/>
	);
};

export default AugmentedEmployeeCard;
